// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--2nMky","limitedwidth":"Page-module--limitedwidth--1FITa"};